import Image from "@components/Image";
import React from "react";
import styles from "./Humans.module.scss";
import cx from "classnames";
import Button from "@components/Button";
import Link from "@components/Link";
import { useTranslationContext } from "@providers/TranslationProvider";
import ClipText from "@components/ClipText/ClipText";
import { useRouteContext } from "@providers/RouteProvider";
interface IProps {
  data: {
    image: { src: string; alt: string };
    label: string | React.ReactNode;
    content: string | React.ReactNode;
    hideDiscoverMore?: boolean;
    title: string | React.ReactNode;
    topic: string | React.ReactNode;
    slug: string;
    description: string | React.ReactNode;
  };
}

export default function Item({ data }: IProps) {
  const { i18n } = useTranslationContext();
  const { router } = useRouteContext();
  return (
    <Link href={router.toUrl("storiesArticle", { slug: data.slug })}>
      <div className={cx("flex flex-col", styles.item)}>
        <Image
          wrapperProps={{ className: cx(styles.image) }}
          src={data.image.src}
          alt={data.image.alt}
          layout="fill"
        />
        <div className="flex flex-col gap-2 mt-6">
          <div className={cx(styles.label)}>{data.title}</div>
          <ClipText rows={5} className={cx(styles.content)}>
            {data.description}
          </ClipText>
        </div>
        {!data?.hideDiscoverMore && (
          <Button
            type="icon"
            suffix="shape-arrow"
            className={cx(styles.discoverMore, "mt-auto")}
            label={i18n.t("Button.discoverMore")}
          />
        )}
      </div>
    </Link>
  );
}
